import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ProjectService} from "@catcore/services";
import {TestRackSetupService} from "@catmodules/models/test-rack/services/test-rack-setup.service";
import {DataTable} from "primeng/primeng";
import {DatatableExportService} from "@catcore/services/datatable-export.service";
import {BreadcrumbService} from "@catmodules/widgets/breadcrumb/services/breadcrumb.service";

@Component({
  selector: 'catapp-test-rack-unit-assignment',
  templateUrl: './test-rack-unit-assignment.component.html',
  styleUrls: ['./test-rack-unit-assignment.component.scss']
})
export class TestRackUnitAssignmentComponent implements OnInit, OnDestroy {

  project = null;
  testRackSetup = null;
  projectSubscription = null;
  testRackName = '';
  hasUnassignedUnits = false;

  @ViewChild('dt')
  dt: DataTable;

  private tableItemSource = [];
  tableItems = [];
  msgs = [];

  showUnassignedUnits = false;

  constructor(private projectService: ProjectService,
              private testRackSetupService: TestRackSetupService,
              private datatableExportService: DatatableExportService,
              private breadcrumbService: BreadcrumbService) { }

  setShowUnassignedUnits(value) {
    this.showUnassignedUnits = value;
    this.updateTableItems();
  }

  ngOnInit() {
    this.projectSubscription = this.projectService.getCurrentProject().subscribe((project) => {
      this.project = project;
      if (this.project !== null && this.project.id !== null) {
        const subscr = this.projectService.getTestRackSetups(this.project)
          .finally(() => {subscr.unsubscribe()})
          .subscribe((testRackSetups: any) => {
            if (testRackSetups.length > 0) {
              this.testRackSetup = testRackSetups[0];
              this.updateData();
            }
          });
      }
    });

    this.breadcrumbService.update([{label: 'Unit Assignment', value: 'testRackUnitAssignment' }]);
  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
  }

  exportToHtml($event) {
    this.datatableExportService.exportToHtml(this.dt, this.project.name + ' - ' + this.testRackName + ' Units');
  }

  exportToCsv($event) {
    this.dt.exportFilename = this.project.name + ' - ' + this.testRackName + ' Units';
    this.dt.exportCSV();
  }

  updateData() {
    if (this.testRackSetup) {
      this.testRackName = this.testRackSetup._links.test_rack.label;
      const subsc = this.testRackSetupService.getAllSubresources(this.testRackSetup.id,
        'unit-assignments')
        .finally(() => { subsc.unsubscribe() })
        .subscribe((unitAssignments) => {
          this.createDataTableItems(unitAssignments);
        });
    }
  }

  createDataTableItems(unitAssignments) {
    this.msgs = [];
    this.hasUnassignedUnits = false;
    unitAssignments.forEach((unitAssignment) => {
      const data = {
        id: unitAssignment.id,
        guiZone: unitAssignment._embedded.unit._links.gui_zone.label,
        unit: unitAssignment._links.unit.label,
        locationAddress: unitAssignment._embedded.unit.location_address,
        testRackZone: unitAssignment._embedded.unit_slot ? unitAssignment._embedded.unit_slot._embedded.zone.name : '',
        slot: unitAssignment._embedded.unit_slot ? unitAssignment._embedded.unit_slot.label : '',
        matchRemarks: unitAssignment.match_remarks
      };
      if (data.slot === '') {
        this.hasUnassignedUnits = true;
      }
      this.tableItemSource = [...this.tableItemSource, data];
    });
    this.updateTableItems();
    if (this.hasUnassignedUnits) {
      this.msgs = [{
        severity: 'warn',
        summary: 'Unassigned units',
        detail: 'Not all units could be assigned to a test rack slot'
      }];
    }
  }

  updateTableItems() {
    this.tableItems = [];
    this.tableItemSource.forEach((item) => {
      if (this.showUnassignedUnits || item.slot !== '') {
        this.tableItems = [...this.tableItems, item];
      }
    });
    this.dt.reset();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/test-rack/components/test-rack-unit-assignment/test-rack-unit-assignment.component.ts